import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { postOrganisationsCurrentAccountsResourceTypesStatusesSelector } from "@/store/live-usage-mgmt/selectors/resource-info-status/postOrganisationsCurrentAccountsResourceTypesStatusesSelector";
import { EmbeddedAccount, ResourceType } from "@/services/cloudchipr.api";
import { liveUsageMgmtAccountsListSelector } from "@/store/live-usage-mgmt/selectors/accounts-data/liveUsageMgmtAccountsListSelector";

type DataType = Record<ResourceType, EmbeddedAccount[]>;

export const liveUsageResourceTypeFailedStatusesByResourceTypeSelector =
  createDraftSafeSelector(
    [
      postOrganisationsCurrentAccountsResourceTypesStatusesSelector,
      liveUsageMgmtAccountsListSelector,
    ],
    (data, accounts) => {
      if (!data) {
        return;
      }

      return data.reduce((acc, item) => {
        item.resource_types?.forEach((resourceTypeData) => {
          const resourceType = resourceTypeData.resource_type;
          if (resourceTypeData.last_collection_failed) {
            const account = accounts?.find(
              (account) => account.id === item.account_id,
            );

            if (!acc[resourceType]) {
              acc[resourceType] = [];
            }

            if (!account) {
              return;
            }

            acc[resourceType].push({
              id: account.id,
              provider: account.type,
              provider_access_type: account.access_type,
              provider_account_id: account.provider_account_id ?? "",
              provider_account_name: account.provider_account_name ?? "",
            });
          }
        });

        return acc;
      }, {} as DataType);
    },
  );
